import React from "react";
import PropTypes from "prop-types";
import tinycolor from "tinycolor2";
import { CustomPicker } from "react-color";
import { Alpha, Hue, Saturation } from "react-color/lib/components/common";
import {
  CustomSlider,
  CustomPointer,
} from "./CustomColorTools/CustomColorTools";
import "./ColorSelectorFlyout.scss";

export class ColorSelectorFlyout extends React.Component {
  static propTypes = {
    color: PropTypes.object,

    onChange: PropTypes.func,

    handleMouseOverFlyout: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      hsl: {
        h: 0,
        s: 0,
        l: 0,
      },
      hsv: {
        h: 0,
        s: 0,
        v: 0,
      },
    };
  }

  componentDidMount() {
    const { color } = this.props;
    const colorConv = tinycolor(color);
    this.setState({
      hsv: colorConv.toHsv(),
      hsl: colorConv.toHsl(),
    });
  }

  componentDidUpdate(prevProps) {
    const { color } = this.props;
    if (prevProps.color !== color) {
      const colorConv = tinycolor(color);
      this.setState({
        hsv: colorConv.toHsv(),
        hsl: colorConv.toHsl(),
      });
    }
  }

  handleHueChange = (hue) => {
    const { onChange } = this.props;
    this.setState({
      hsl: hue,
    });
    const color = tinycolor(hue);
    onChange(color.toRgb());
  };

  handleSaturationChange = (hsv) => {
    const { onChange } = this.props;
    const color = tinycolor(hsv);
    onChange(color.toRgb());
  };

  handleMouseEnter = () => {
    const { handleMouseOverFlyout } = this.props;
    handleMouseOverFlyout(true);
  };

  handleMouseLeave = () => {
    const { handleMouseOverFlyout } = this.props;
    handleMouseOverFlyout(false);
  };

  render() {
    const { color } = this.props;
    const { hsl, hsv } = this.state;

    return (
      <div
        className="CustomColorSelector"
        data-testid="CustomColorSelector"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="Saturation">
          <Saturation
            hsl={hsl}
            hsv={hsv}
            pointer={CustomPointer}
            onChange={this.handleSaturationChange}
          />
        </div>
        <div className="ScrollBar">
          <Hue
            hsl={hsl}
            pointer={CustomSlider}
            onChange={this.handleHueChange}
            direction="horizontal"
          />
        </div>
        <div className="ScrollBar">
          <Alpha
            rgb={color}
            hsl={hsl}
            pointer={CustomSlider}
            onChange={this.handleHueChange}
          />
        </div>
      </div>
    );
  }
}

export default CustomPicker(ColorSelectorFlyout);
